const MIN_DIM = 10;
const WARNING_DIM = 192; // 16 feet
const MAX_SPLICE = 80.0;
const MAX_SPAN = 85.0;
// Clip placement rules
const CLIP_EDGE = 6.0;
const CLIP_MIN_SP = 4.0;
const OBS_ZONE = 3.5;
const THEME = {
    accent: '#0056b3',
    alumLight: '#f0f0f0',
    alumDark: '#444444',
    supportFill: '#e0e0e0',
    supportStroke: '#444444',
    blackFill: '#1a1a1a',
    blackStroke: '#000000',
    clipFill: '#e74c3c',
    clipPassive: '#555555',
    danger: '#dc3545',
};
const HD = {
    aluminum: '#e0e0e0',
    aluminumDark: '#666666',
    screwBlack: '#111111',
    screwSilver: '#cccccc',
    lockHousing: '#aeb6bf',
    clipDark: '#333333',
};
const DEFAULT_TIERS = {
    retail: { label: 'Retail', frame: 11.5, fabric: 9.5 },
    reseller: { label: 'Reseller', frame: 9.5, fabric: 7.5 },
    volume: { label: 'High Volume', frame: 8.0, fabric: 6.0 },
    custom: { label: 'Custom', frame: 10.0, fabric: 8.0 },
};
const RAW_COSTS_CONFIG = [
    { id: 'frameRail', label: 'Frame Rail', unit: '$/LF', def: 2.70 },
    { id: 'supportBar', label: 'Support Bar', unit: '$/LF', def: 2.52 },
    { id: 'cornerConn', label: 'Corner Conn.', unit: '$/pc', def: 1.85 },
    { id: 'spliceConn', label: 'Splice Conn.', unit: '$/pc', def: 2.14 },
    { id: 'supportEndClip', label: 'Support End Clip', unit: '$/pc', def: 2.37 },
    { id: 'hangingTab', label: 'Hanging Clip', unit: '$/pc', def: 0.59 },
    { id: 'cleat', label: 'Cleat', unit: '$/pc', def: 1.25 },
    { id: 'screw', label: 'Wall Screw', unit: '$/pc', def: 0.03 },
    { id: 'anchor', label: 'Wall Anchor', unit: '$/pc', def: 0.04 },
    { id: 'printPerSqFt', label: 'Print Media', unit: '$/sqft', def: 3.50 },
];
const FRAME_SPECS = {
    frameDepth: 1.0,
    supportWidth: 1.6,
    maxSplice: MAX_SPLICE,
    maxSpan: MAX_SPAN,
};
const TABS = {
    QUOTE: 'quote',
    PRODUCTION: 'production',
    ASSEMBLY: 'assembly',
};
const FRAME_COLORS = {
    SILVER: 'silver',
    BLACK: 'black',
};
const ASSEMBLY_STEP_TYPES = {
    ORGANIZE: 'ORGANIZE',
    CORNERS: 'CORNERS',
    SPLICES: 'SPLICES',
    SUPPORTS: 'SUPPORTS',
    WALL_BRACKETS: 'WALL_BRACKETS',
    HANG: 'HANG',
    GRAPHIC: 'GRAPHIC',
};
const BOM_TYPES = {
    FRAME: 'Frame',
    SUPPORT: 'Support',
};
const BOM_NAMES = {
    VERTICAL_SUPPORT_BAR: 'Vertical Support Bar',
    HORIZONTAL_SUPPORT_BAR: 'Horizontal Support Bar',
};
const HARDWARE_LABELS = {
    FRAME_RAIL: 'Frame Rail',
    SUPPORT_BAR: 'Support Bar',
    CORNER_CONNECTOR: 'Corner Connector',
    SPLICE_CONNECTOR: 'Splice Connector',
    SUPPORT_END_CLIP: 'Support End Clip',
    HANGING_CLIP: 'Hanging Clip (Wall)',
    CLEAT: 'Cleat',
    SCREW_ANCHOR: 'Screw / Anchor',
};
const HARDWARE_LEGEND = [
    // --- Structural Materials ---
    { label: HARDWARE_LABELS.FRAME_RAIL, color: '#F3F4F6', border: '#9CA3AF', shape: 'rect' }, // Bright Platinum
    { label: HARDWARE_LABELS.SUPPORT_BAR, color: '#94A3B8', border: '#334155', shape: 'rect' }, // Steel Blue-Gray
    // --- Internal Hardware ---
    { label: HARDWARE_LABELS.CORNER_CONNECTOR, color: '#2563EB', border: '#1E3A8A', shape: 'path' }, // Royal Blue
    { label: HARDWARE_LABELS.SPLICE_CONNECTOR, color: '#D946EF', border: '#701A75', shape: 'rect' }, // Magenta
    { label: HARDWARE_LABELS.SUPPORT_END_CLIP, color: '#06B6D4', border: '#164E63', shape: 'rect' }, // Cyan
    // --- Mounting ---
    { label: HARDWARE_LABELS.HANGING_CLIP, color: '#EAB308', border: '#713F12', shape: 'rect' }, // Yellow
    { label: HARDWARE_LABELS.CLEAT, color: '#64748B', border: '#1E293B', shape: 'rect' }, // Slate
    // --- Fasteners (THE TOP LAYER) ---
    // Using Chartreuse/Lime for maximum contrast against Magenta and Dark Spines
    { label: HARDWARE_LABELS.SCREW_ANCHOR, color: '#ADFF2F', border: '#2D5A27', shape: 'circle' },
];
export { MIN_DIM, WARNING_DIM, MAX_SPLICE, MAX_SPAN, CLIP_EDGE, CLIP_MIN_SP, OBS_ZONE, THEME, HD, DEFAULT_TIERS, RAW_COSTS_CONFIG, FRAME_SPECS, BOM_NAMES, HARDWARE_LABELS, HARDWARE_LEGEND, TABS, FRAME_COLORS, ASSEMBLY_STEP_TYPES, BOM_TYPES, };
